import { Reducer } from 'redux';

import { LOCATION_CHANGE } from 'react-router-redux';
import { LocationHistoryState } from './types';

const defaultState: LocationHistoryState = {
    previousLocation: null,
    currentLocation: null,
};

const reducer: Reducer<LocationHistoryState> = (state = defaultState, action): LocationHistoryState => {
    const { type, payload } = action;

    if (type === LOCATION_CHANGE) {
        return {
            previousLocation: state.currentLocation,
            currentLocation: payload.location,
        };
    }

    return state;
};

export { reducer as locationHistory };

export default reducer;
